/* eslint-env node */
const dmyt_to_ymdt = t =>  t && (t.substr(4, 2) + t.substr(2, 2) + t.substr(0, 2) + t.substr(6))

module.exports = dmyt_to_ymdt;
